import { classNames } from "@/utils/styling-utils";
import type { ReactNode } from "react";

interface GridContainerProps {
  children: ReactNode;
  columnLayout: "three_columns_responsive" | "two_columns_responsive" | "two_columns" | "five_columns" | "one_column";
  rowSpacing?: "xx-small" | "x-small" | "small" | "medium" | "large" | "x-large" | "xx-large";
  columnSpacing?: "xx-small" | "x-small" | "small" | "medium" | "large" | "x-large" | "xx-large";
  horizontalPlacement?: "center" | "left";
}

const cssClasses = (property: string, value?: string) => {
  if (!value) {
    return;
  }

  const className = `grid-container__${property}--${value}`;
  return className;
};

export const GridContainer = ({
  children,
  columnLayout,
  rowSpacing = "medium",
  columnSpacing = "medium",
  horizontalPlacement,
}: GridContainerProps) => {
  const cssRowSpacingClass = cssClasses("row-spacing", rowSpacing);
  const csscolumnSpacingClass = cssClasses("column-spacing", columnSpacing);
  const csscolumnLayout = cssClasses("column-layout", columnLayout);
  const cssJustifyClass = cssClasses("horizontal-placement", horizontalPlacement);

  return (
    <div
      className={classNames(
        "grid-container",
        cssRowSpacingClass,
        csscolumnSpacingClass,
        csscolumnLayout,
        cssJustifyClass,
      )}
    >
      {children}
    </div>
  );
};
